/* ================================================================
    Timeline scroll
=========================================== */

class Timeline {
  private timeline: HTMLElement;
  private decadeAnchorLinks: NodeListOf<HTMLAnchorElement>;
  private years: NodeListOf<HTMLElement>;
  private backToTop: HTMLElement;
  constructor(timeline: HTMLElement) {
    this.timeline = timeline;
    this.decadeAnchorLinks = this.timeline.querySelectorAll('.decade-anchors__link') as NodeListOf<HTMLAnchorElement>;
    this.years = this.timeline.querySelectorAll('.year__item') as NodeListOf<HTMLElement>;
    this.backToTop = this.timeline.querySelector('.back-to-top') as HTMLElement;
  }

  init(): void {
    const $backToTop = $(this.backToTop);
    this.decadeAnchorLinks.forEach((decadeAnchorLink) => {
      decadeAnchorLink.addEventListener('click', () => {
        const target = document.getElementById(decadeAnchorLink.href.split('#')[1]) as HTMLElement;

        if (target) {
          $backToTop.fadeIn();
        }
      });
    });

    $backToTop.on('click', () => {
      $backToTop.fadeOut();
    });

    this.CountYearItems();
  }

  private CountYearItems(): void {
    this.years.forEach((year, i) => {
      if (i % 2 === 1) {
        year.classList.add('alt');
      }
    });
  }
}

document.querySelectorAll('[timeline]').forEach((timeline) => {
  new Timeline(timeline as HTMLElement).init();
});
